// apps/scheduler-worker/src/hooks/usePendingSync.ts
import { useState, useEffect, useCallback } from 'react';
import { getPendingCount } from '../lib/db';

/**
 * Hook to track pending sync count for UI indicator.
 */
export function usePendingSync() {
  const [pendingCount, setPendingCount] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const count = await getPendingCount();
      setPendingCount(count);
    } catch {
      // IndexedDB not available
      setPendingCount(0);
    }
  }, []);

  useEffect(() => {
    refresh();

    // Poll every 5 seconds for updates
    const interval = setInterval(refresh, 5000);
    return () => clearInterval(interval);
  }, [refresh]);

  return { pendingCount, refresh };
}
